import { useRouter } from '@mi-front/core';
import { List, ListItem, ListItemButton, ListItemText, Paper } from '@mui/material';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useMentionsEnabledForActiveStation } from '../../../../hooks/useMentionsEnabledForActiveStation';
import { uploadLinksMessages } from './upload-links-messages';

export function UploadLinks() {
  const { match } = useRouter();
  const { $t } = useIntl();

  return (
    <Paper sx={{ width: '100%' }}>
      <nav>
        <List>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to={`${match.url}/audios`}
              activeClassName="Mui-selected"
            >
              <ListItemText primary={$t(uploadLinksMessages.adAudios)} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to={`${match.url}/ad-schedules-plk`}
              activeClassName="Mui-selected"
            >
              <ListItemText primary={$t(uploadLinksMessages.adSchedulesPlk)} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to={`${match.url}/ad-schedules-asc`}
              activeClassName="Mui-selected"
            >
              <ListItemText primary={$t(uploadLinksMessages.adSchedulesAsc)} />
            </ListItemButton>
          </ListItem>
          {useMentionsEnabledForActiveStation() && (
            <ListItem disablePadding>
              <ListItemButton
                component={NavLink}
                to={`${match.url}/mentions-schedules-csv`}
                activeClassName="Mui-selected"
              >
                <ListItemText primary={$t(uploadLinksMessages.liveMentionSchedulesCsv)} />
              </ListItemButton>
            </ListItem>
          )}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to={`${match.url}/bcr-upload`}
              activeClassName="Mui-selected"
            >
              <ListItemText primary={$t(uploadLinksMessages.bcrUpload)} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to={`${match.url}/ltx-upload`}
              activeClassName="Mui-selected"
            >
              <ListItemText primary={$t(uploadLinksMessages.ltxUpload)} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to={`${match.url}/avg-upload`}
              activeClassName="Mui-selected"
            >
              <ListItemText primary={$t(uploadLinksMessages.avgUpload)} />
            </ListItemButton>
          </ListItem>
        </List>
      </nav>
    </Paper>
  );
}
